module.exports = __webpack_public_path__ + "img/Game_target_Z-12.ffdcd6c4.png";